import { createSlice } from '@reduxjs/toolkit'

// export interface dossiers extends Array<dossier>{}


const noteSlice = createSlice({
  name: 'note',
  initialState: {
    loaded: false,
    data: [],
  },
  reducers: {
    load: (state, action) => {
        state.loaded = true
        state.data = action.payload
    }
  }
})

export const actions = noteSlice.actions;
export default noteSlice.reducer;